export default __webpack_public_path__ + "static/media/208.10173a67.svg";